<div>
  <app-email-modal #emailModal [meetingBotId]="botId" [emails]="emails"></app-email-modal>
  <div class="opportunity-header">
    <div>
      <a [routerLink]="'/dashboard'" class="back-link">
        <i class="fas fa-chevron-left"></i>
        Go back to All Opportunities
      </a>
      <h1 class="opportunity-title">{{ title }}</h1>
    </div>

    <div class="last-updated">
      <select
        (change)="switchVersion($event)"
        class="date-selector"
        aria-label="View previous meeting updates"
      >
        <option value="" disabled>View previous updates</option>
        @for (oppDate of opportunityDates; track $index) {
        <option [value]="oppDate?.meeting_bot_id">
          {{ oppDate.created_at | date : "d MMM, y" }}
        </option>
        }
      </select>
    </div>
  </div>

  <div class="content-wrapper">
    <div class="opportunity-layout">
      <section class="left-pane" #leftCol>
        <article class="surface-card summary-card">
          <header class="summary-card__header">
            <div>
              <h2 class="summary-card__title">Meeting Summary</h2>
              <span *ngIf="lastUpdated" class="summary-card__meta">
                Updated {{ lastUpdated | date : 'd MMM, y' }}
              </span>
            </div>
            <div class="summary-card__controls">
              <div
                class="summary-toggle"
                (click)="$event.stopPropagation()"
                [class.summary-toggle--disabled]="!isExtendedSummaryAvailable"
              >
                <button
                  type="button"
                  class="toggle-label"
                  [class.active]="summaryMode === 'short'"
                  [attr.aria-pressed]="summaryMode === 'short'"
                  (click)="onSummaryOptionClick('short', $event)"
                >
                  Short
                </button>
                <button
                  type="button"
                  class="toggle-track"
                  role="switch"
                  [attr.aria-checked]="summaryMode === 'extended'"
                  aria-label="Toggle summary view"
                  [class.extended]="summaryMode === 'extended'"
                  [disabled]="!isExtendedSummaryAvailable"
                  [attr.aria-disabled]="!isExtendedSummaryAvailable"
                  [attr.title]="!isExtendedSummaryAvailable ? extendedSummaryUnavailableCopy : null"
                  (click)="onSummaryToggleClick($event)"
                >
                  <span class="toggle-thumb" [class.extended]="summaryMode === 'extended'">
                    <i
                      class="fas"
                      [ngClass]="summaryMode === 'extended' ? 'fa-feather-alt' : 'fa-terminal'"
                    ></i>
                  </span>
                </button>
                <button
                  type="button"
                  class="toggle-label"
                  [class.active]="summaryMode === 'extended'"
                  [attr.aria-pressed]="summaryMode === 'extended'"
                  [disabled]="!isExtendedSummaryAvailable"
                  [attr.title]="!isExtendedSummaryAvailable ? extendedSummaryUnavailableCopy : null"
                  (click)="onSummaryOptionClick('extended', $event)"
                >
                  Long
                </button>
              </div>
              <button
                type="button"
                class="collapse-btn"
                [attr.aria-expanded]="!isSummaryCollapsed"
                [attr.aria-label]="isSummaryCollapsed ? 'Expand meeting summary' : 'Collapse meeting summary'"
                (click)="toggleSummary()"
              >
                <i
                  class="fas fa-chevron-down"
                  [style.transform]="!isSummaryCollapsed ? 'rotate(180deg)' : 'rotate(0deg)'"
                ></i>
              </button>
            </div>
          </header>

          @if (!isSummaryCollapsed) {
          <div class="summary-card__body">
            <div class="formatted-summary" [innerHTML]="activeSummaryDetail"></div>

            @if (summaryMode === 'short') {
            <section class="summary-section">
              <header class="summary-section__header">
                <div>
                  <h3 class="summary-section__title">Qualify</h3>
                  <span class="summary-section__meta" *ngIf="answeredQuestions.length">
                    {{ answeredQuestions.length }} answered · {{ unansweredQuestions.length }} pending
                  </span>
                </div>
                <button
                  type="button"
                  class="icon-button"
                  [class.active]="isGlobalEditMode"
                  (click)="toggleGlobalEdit()"
                  aria-label="Toggle edit mode"
                >
                  <i class="fas fa-pencil"></i>
                </button>
              </header>

              <div class="question-list">
                @for (opportunityCardDetail of answeredQuestions; track opportunityCardDetail.question_id) {
                <div class="question-item" [id]="opportunityCardDetail.question_id">
                  <div class="question-item__prompt">
                    {{ opportunityCardDetail?.question_text ?? '-' }}
                  </div>
                  @if (!isGlobalEditMode) {
                  <div class="question-item__answer">
                    {{ opportunityCardDetail.answers[0].answer_text }}
                  </div>
                  } @else {
                  <textarea
                    [(ngModel)]="editValues[opportunityCardDetail.question_id]"
                    class="question-item__textarea"
                    placeholder="Enter your answer..."
                  ></textarea>
                  }
                </div>
                }
              </div>

              @if (unansweredQuestions.length > 0) {
              <section class="unanswered" [class.collapsed]="isUnansweredCollapsed">
                <header class="unanswered__header">
                  <button
                    type="button"
                    class="unanswered__trigger"
                    (click)="toggleUnanswered()"
                    [attr.aria-expanded]="!isUnansweredCollapsed"
                  >
                    <span>Unanswered Questions ({{ unansweredQuestions.length }})</span>
                    <i
                      class="fas fa-chevron-down"
                      [style.transform]="!isUnansweredCollapsed ? 'rotate(180deg)' : 'rotate(0deg)'"
                    ></i>
                  </button>
                </header>
                @if (!isUnansweredCollapsed) {
                <div class="question-list">
                  @for (opportunityCardDetail of unansweredQuestions; track opportunityCardDetail.question_id) {
                  <div class="question-item" [id]="opportunityCardDetail.question_id">
                    <div class="question-item__prompt">
                      {{ opportunityCardDetail?.question_text ?? '-' }}
                    </div>
                    @if (!isGlobalEditMode) {
                    <div class="question-item__answer question-item__answer--empty">
                      No answer provided yet
                    </div>
                    } @else {
                    <textarea
                      [(ngModel)]="editValues[opportunityCardDetail.question_id]"
                      class="question-item__textarea"
                      placeholder="Enter your answer..."
                    ></textarea>
                    }
                  </div>
                  }
                </div>
                }
              </section>
              }

              @if (isGlobalEditMode) {
              <footer class="card-actions">
                <button class="btn btn-primary" (click)="saveAllAnswers()">
                  Save All Answers
                </button>
                <button class="btn btn-secondary" (click)="cancelEdit()">
                  Cancel
                </button>
              </footer>
              }
            </section>
            }

            <section class="summary-section">
              <header class="summary-section__header summary-section__header--sub">
                <h3 class="summary-section__title">Next Steps</h3>
              </header>
              @if (nextSteps.length) {
              <ol class="next-steps__list">
                <li *ngFor="let step of nextSteps">
                  {{ step }}
                </li>
              </ol>
              } @else {
              <div class="next-steps__empty">--</div>
              }
            </section>

            <button type="button" class="email-btn" (click)="openEmailPopup()">
              Email
            </button>
          </div>
          }
        </article>
      </section>

      <aside class="right-pane">
        @if (recordingUrl) {
        <div class="meeting-video">
          <video
            #videoPlayer
            controls
            controlsList="nodownload"
            preload="metadata"
            (play)="onVideoPlay()"
            (pause)="onVideoPause()"
            (loadstart)="onVideoLoadStart()"
            (canplay)="onVideoCanPlay()"
            (loadeddata)="onVideoLoadedData()"
          >
            <source [src]="recordingUrl" type="video/mp4" />
            <source [src]="recordingUrl" type="video/webm" />
            <source [src]="recordingUrl" type="video/mov" />
            Your browser does not support the video tag.
          </video>
          <div class="media-loading" *ngIf="isVideoLoading">
            <div class="media-loading__logo"></div>
            <div class="media-loading__text">Loading video...</div>
          </div>
        </div>
        } @else {
        <div class="meeting-video meeting-video--empty">
          <i class="fas fa-video-slash"></i>
          <p>No recording available for this meeting</p>
          <small>Recording may not have been enabled or is still processing</small>
        </div>
        }

        <div class="surface-card transcript-card" [class.collapsed]="isTranscriptCollapsed">
          <header class="card-section__header">
            <span class="card-section__title">Transcript</span>
            <button
              type="button"
              class="collapse-btn"
              [attr.aria-expanded]="!isTranscriptCollapsed"
              [attr.aria-label]="isTranscriptCollapsed ? 'Expand transcript section' : 'Collapse transcript section'"
              (click)="toggleTranscript()"
            >
              <i
                class="fas fa-chevron-down"
                [style.transform]="!isTranscriptCollapsed ? 'rotate(180deg)' : 'rotate(0deg)'"
              ></i>
            </button>
          </header>
          @if (!isTranscriptCollapsed) {
          <div class="transcript-card__body" #rightScroll>
            <div class="transcript-entry" *ngFor="let item of meetingTranscripts">
              <span class="transcript-speaker">{{ item.speaker }}:</span>
              <span>{{ item.transcript }}</span>
            </div>
          </div>
          }
        </div>
      </aside>
    </div>
  </div>
</div>
